// What the user is told when the request to execute a test is refused (backend plan, §2.2, §6.4). The test did
// not fail: the execution never started, so there is nothing to explain from the store, only the refusal.
//
// Used only by the three calls that execute a test (the table, the list, the save-and-run), not by the global
// httpErrorsHandler: elsewhere a 404 or a 403 does mean a page that does not exist or is not allowed.

const BASE = 'efficiencyTestFailures.rejections.'

// Refusals the server explains with `{ "error": "<code>" }` (422).
const BY_ERROR_CODE = {
  NotExecutable: { messageKey: BASE + 'notExecutable', reload: true },
  BlockedByLastError: { messageKey: BASE + 'blockedByLastError', reload: true },
  TestedProductNoLongerInTest: { messageKey: BASE + 'testedProductNoLongerInTest', reload: false },
}

const BY_STATUS = {
  403: { messageKey: BASE + 'forbidden', reload: false },
  404: { messageKey: BASE + 'notFound', reload: true },
}

// A refusal the frontend does not know still says something: never silence.
const UNKNOWN_REFUSAL = { messageKey: 'common.genericError', reload: false }

async function errorCodeOf(response) {
  try {
    const body = await response.json()
    return body && body.error
  } catch (e) {
    return null
  }
}

/**
 * @param {Error} err what the request threw
 * @returns {Promise<{ messageKey: string, reload: boolean }|null>} the text to show and whether the list is
 *   stale; null when it is not a refusal (no response, or a status the global handling takes care of)
 */
export async function describeExecuteRejection(err) {
  const response = err && err.response
  if (!response) {
    return null
  }

  if (BY_STATUS[response.status]) {
    return BY_STATUS[response.status]
  }

  if (response.status === 422) {
    return BY_ERROR_CODE[await errorCodeOf(response)] || UNKNOWN_REFUSAL
  }

  return null
}
